/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const RoiConfidence = {
  Low: "low",
  Med: "med",
  High: "high",
} as const;
export type RoiConfidence = ClosedEnum<typeof RoiConfidence>;

export const SkillEfficacyScoredSessionSurface = {
  Dev: "dev",
  Assistant: "assistant",
} as const;
export type SkillEfficacyScoredSessionSurface = ClosedEnum<
  typeof SkillEfficacyScoredSessionSurface
>;

export type SkillEfficacyScoredSession = {
  activatedAt: Date;
  estimatedMinutesSaved?: number | undefined;
  estimatedTurnsSaved?: number | undefined;
  flags: Array<string>;
  gramChatId?: string | undefined;
  id: string;
  rationale: string;
  roiConfidence?: RoiConfidence | undefined;
  score: number;
  scoredAt: Date;
  skillId: string;
  skillVersionId: string;
  surface: SkillEfficacyScoredSessionSurface;
};

/** @internal */
export const RoiConfidence$inboundSchema: z.ZodMiniEnum<typeof RoiConfidence> =
  z.enum(RoiConfidence);

/** @internal */
export const SkillEfficacyScoredSessionSurface$inboundSchema: z.ZodMiniEnum<
  typeof SkillEfficacyScoredSessionSurface
> = z.enum(SkillEfficacyScoredSessionSurface);

/** @internal */
export const SkillEfficacyScoredSession$inboundSchema: z.ZodMiniType<
  SkillEfficacyScoredSession,
  unknown
> = z.pipe(
  z.object({
    activated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    estimated_minutes_saved: z.optional(z.number()),
    estimated_turns_saved: z.optional(z.number()),
    flags: z.array(z.string()),
    gram_chat_id: z.optional(z.string()),
    id: z.string(),
    rationale: z.string(),
    roi_confidence: z.optional(RoiConfidence$inboundSchema),
    score: z.number(),
    scored_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    skill_id: z.string(),
    skill_version_id: z.string(),
    surface: SkillEfficacyScoredSessionSurface$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "activated_at": "activatedAt",
      "estimated_minutes_saved": "estimatedMinutesSaved",
      "estimated_turns_saved": "estimatedTurnsSaved",
      "gram_chat_id": "gramChatId",
      "roi_confidence": "roiConfidence",
      "scored_at": "scoredAt",
      "skill_id": "skillId",
      "skill_version_id": "skillVersionId",
    });
  }),
);

export function skillEfficacyScoredSessionFromJSON(
  jsonString: string,
): SafeParseResult<SkillEfficacyScoredSession, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillEfficacyScoredSession$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillEfficacyScoredSession' from JSON`,
  );
}
